/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-console */
let isDev = true;

export const setIsDev = (flag: boolean): void => {
	isDev = flag;
};

export const deprecationWarning = isDev ? console.warn : (): void => undefined;

// Given an object where each key represents a deprecated property and
// the corresponding value (if given) represents the alternative, prints
// a warning if the given member name is deprecated.
const warnIfDeprecated = (deprecations: object, member: string | symbol | number, message: string): void => {
	const [deprecated, alternative] =
		Object.entries(deprecations).find(([deprecated, _]) => deprecated === member) || [];

	if (deprecated) {
		const messages = ['!!! UX1Framework WARNING !!!'];

		message && messages.push(message);
		messages.push(`${deprecated} is deprecated.`);

		if (alternative) {
			messages.push(`Please, use ${alternative} instead.`);
		}

		const err = new Error();
		const stacks = err.stack?.split('\n') || [];
		const callFrom = stacks.length ? stacks[stacks.length - 1].trim() : 'none';

		messages.push('Call from: ' + callFrom);

		deprecationWarning(messages.join('\n'));
	}
};

export const deprecateProperties = (target: object, deprecations = {}, message: string = ''): any => {
	if (!isDev) {
		return target;
	}

	return new Proxy(target, {
		get(target, key): any {
			warnIfDeprecated(deprecations, key, message);

			return Reflect.get(target, key);
		},

		set(target, key, value): any {
			warnIfDeprecated(deprecations, key, message);

			return Reflect.set(target, key, value);
		}
	});
};
